import { AvailableLookupOsUpdate as AvailableLookupOsUpdateModel } from '@rocksoft/mdm-sdk-v2';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface AvailableLookupOsUpdate extends AvailableLookupOsUpdateModel {
  udid: string;
}

export type AvailableLookupOsUpdateState = EntityState<AvailableLookupOsUpdate>;

export function selectId(availableLookupOsUpdate: AvailableLookupOsUpdate): string {
  return `${availableLookupOsUpdate.udid}-${availableLookupOsUpdate.productVersion}`;
}

export const adapter: EntityAdapter<AvailableLookupOsUpdate> = createEntityAdapter<AvailableLookupOsUpdate>({
  selectId,
});

export const initialState: AvailableLookupOsUpdateState = adapter.getInitialState();
